import global$1 from './global.js';
import isCallable$1 from './is-callable.js';
import tryToString$1 from './try-to-string.js';

var global = global$1;
var isCallable = isCallable$1;
var tryToString = tryToString$1;
var TypeError = global.TypeError; // `Assert: IsCallable(argument) is true`

var aCallable = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};

export { aCallable as default };
